import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { Button, Col, Row } from "reactstrap";

import { BsWallet2 } from "react-icons/bs";
import {
  FaExchangeAlt,
  FaMoneyBillWave
} from "react-icons/fa";
import { FaMoneyBillTransfer, FaRegMoneyBill1 } from "react-icons/fa6";
import { IoCashOutline } from "react-icons/io5";
import { encryptStorage } from "../../constants/EncryptStorage";
import { GetLanguageString } from "../helper/Components";
import { isUsraRole } from "../helper/Method";
import { ApiFinance } from "./ApiFinance";
import { ApiFund } from "./ApiFund";
import { CashAccountBalanceCard, AmanatAccountBalanceCard, MetricCard } from "./BalanceCards";

const QuickManageFund = ({ history }) => {
  const unitTypeName = encryptStorage.getItem("unitTypeName");
  const loggedInUnitId = parseInt(encryptStorage.getItem("loggedInUnitId"));
  const [balances, setBalances] = useState({
    cashAccountBalance: 0,
    amanatAccountBalance: 0,
  });
  const [holding, setHolding] = useState(null);
  const [loadingBalances, setLoadingBalances] = useState(true);
  const usra = isUsraRole();

  useEffect(() => {
    if (usra) {
      ApiFund()
        .GetUsraHolding(loggedInUnitId)
        .then((res) => setHolding(res.data))
        .catch(() => setHolding(null))
        .finally(() => setLoadingBalances(false));
      return;
    }
    ApiFinance()
      .GetCashToAmanatTransferData(loggedInUnitId)
      .then((res) => {
        if (res.data) {
          setBalances({
            cashAccountBalance: res.data.cashAccountBalance || 0,
            amanatAccountBalance: res.data.amanatAccountBalance || 0,
          });
        }
      })
      .catch((err) => {
        console.error("Error fetching balances in QuickManageFund:", err);
      })
      .finally(() => {
        setLoadingBalances(false);
      });
  }, [loggedInUnitId, usra]);

  return (
    <>
      <div className="wrapper wrapper-content wrapper-custom">
        {/* Elegant side-by-side KPI Balance Cards */}
        <Row style={{ marginBottom: "15px" }}>
        {usra ? (
          <>
            <CashAccountBalanceCard
              balance={holding?.heldAmount || 0}
              loading={loadingBalances}
              labelKey="usra_cash_holding"
              badgeText="Held"
              colProps={{ md: "4", sm: "12", className: "mb-3" }}
            />
            <MetricCard
              labelKey="usra_receipt_count"
              badgeText="Receipts"
              value={holding?.heldCount || 0}
              format="integer"
              tone="slate"
              loading={loadingBalances}
              colProps={{ md: "4", sm: "12", className: "mb-3" }}
              icon={
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#39576B" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                  <path d="M14 2v6h6M8 13h8M8 17h8" />
                </svg>
              }
            />
            <MetricCard
              labelKey="usra_oldest_age"
              badgeText="Days"
              value={holding?.oldestAgeDays || 0}
              format="days"
              tone="emerald"
              loading={loadingBalances}
              colProps={{ md: "4", sm: "12", className: "mb-3" }}
              icon={
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#237A6E" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10" />
                  <path d="M12 6v6l4 2" />
                </svg>
              }
            />
            {holding?.isBlocked ? (
              <Col md="12" className="mb-2">
                <p className="text-warning mb-0">
                  <GetLanguageString props="usra_holding_limit_warning" />
                </p>
              </Col>
            ) : holding?.amountWarning || holding?.daysWarning ? (
              <Col md="12" className="mb-2">
                <p className="text-warning mb-0">
                  <GetLanguageString props="usra_holding_warning" />
                </p>
              </Col>
            ) : null}
          </>
        ) : (
          <>
          <CashAccountBalanceCard
            balance={balances.cashAccountBalance}
            loading={loadingBalances}
            colProps={{ md: "6", sm: "12", className: "mb-3" }}
          />
          <AmanatAccountBalanceCard
            balance={balances.amanatAccountBalance}
            loading={loadingBalances}
            colProps={{ md: "6", sm: "12", className: "mb-3" }}
          />
          </>
        )}
        </Row>

        <div className="ibox">
          <div className="ibox-content panel-body">
            <h3>{<GetLanguageString props="transactions_income" />}</h3>

            <Row>
              <Col xl="1" className="text-center">
                <Button
                  className="btn-danger dim btn-large-dim"
                  onClick={() =>
                    history.push({
                      pathname: `/funds/addInfaqCashInHand`,
                    })
                  }
                >
                  <FaRegMoneyBill1 size={50} />
                </Button>
                <h4>
                  {
                    <GetLanguageString props="transactions_infaq_to_cash_in_hand" />
                  }
                </h4>
              </Col>

              <Col xl="1" className="text-center">
                <Button
                  className="btn-success dim btn-large-dim"
                  onClick={() =>
                    history.push({
                      pathname: `/funds/addBulkInfaq`,
                    })
                  }
                >
                  <FaMoneyBillWave size={50} />
                </Button>
                <h4>{<GetLanguageString props="funds_add_bulk_fund" />}</h4>
              </Col>

              {!isUsraRole() && (
              <Col xl="1" className="text-center">
                <Button
                  className="btn-info dim btn-large-dim"
                  onClick={() =>
                    history.push({
                      pathname: `/funds/addInfaqAmanatAccount`,
                    })
                  }
                >
                  <FaRegMoneyBill1 size={50} />
                </Button>
                <h4>
                  {
                    <GetLanguageString props="transactions_infaq_to_amanat_account" />
                  }
                </h4>
              </Col>
              )}

              {isUsraRole() && (
              <Col xl="1" className="text-center">
                <Button
                  className="btn-warning dim btn-large-dim"
                  onClick={() =>
                    history.push({
                      pathname: `/funds/requestUsraRemittance`,
                    })
                  }
                >
                  <FaMoneyBillTransfer size={50} />
                </Button>
                <h4>
                  {<GetLanguageString props="usra_forward_cash" />}
                </h4>
              </Col>
              )}

              {unitTypeName === "Tanzeem" && !isUsraRole() && (
              <Col xl="1" className="text-center">
                <Button
                  className="btn-warning dim btn-large-dim"
                  onClick={() =>
                    history.push({
                      pathname: `/funds/incomingUsraRemittances`,
                    })
                  }
                >
                  <FaMoneyBillTransfer size={50} />
                </Button>
                <h4>
                  {<GetLanguageString props="usra_incoming_remittances" />}
                </h4>
              </Col>
              )}

              {isUsraRole() ? (
              <Col xl="1" className="text-center">
                <Button
                  className="btn-primary dim btn-large-dim"
                  onClick={() =>
                    history.push({
                      pathname: `/funds/manageUsraInfaq`,
                    })
                  }
                >
                  <BsWallet2 size={50} />
                </Button>
                <h4>{<GetLanguageString props="manage_infaq" />}</h4>
              </Col>
              ) : (
              <Col xl="1" className="text-center">
                <Button
                  className="btn-primary dim btn-large-dim"
                  onClick={() =>
                    history.push({
                      pathname: `/funds/manageIncome`,
                    })
                  }
                >
                  <BsWallet2 size={50} />
                </Button>
                <h4>{<GetLanguageString props="manage_income" />}</h4>
              </Col>
              )}
              {!isUsraRole() && (
                <>
                  <Col xl="1" className="text-center">
                    <Button
                      className="btn-success dim btn-large-dim"
                      onClick={() =>
                        history.push({
                          pathname: `/funds/otherIncome`,
                        })
                      }
                    >
                      <IoCashOutline size={50} />
                    </Button>
                    <h4>{<GetLanguageString props="funds_other_income" />}</h4>
                  </Col>
                  {unitTypeName === "Halqa" && (
                    <Col xl="1" className="text-center">
                      <Button
                        className="btn-warning dim btn-large-dim"
                        onClick={() =>
                          history.push({
                            pathname: `/funds/otherIncomeLoanFromMarkaz`,
                          })
                        }
                      >
                        <IoCashOutline size={50} />
                      </Button>
                      <h4>
                        {
                          <GetLanguageString props="funds_other_income_loan_from_markaz" />
                        }
                      </h4>
                    </Col>
                  )}
                  {unitTypeName === "Halqa" && (
                    <>
                      <Col xl="1" className="text-center">
                        <Button
                          className="btn-primary dim btn-large-dim"
                          onClick={() =>
                            history.push({
                              pathname: `/funds/OtherIncomeTarbiatiCourseReimbursment`,
                            })
                          }
                        >
                          <IoCashOutline size={50} />
                        </Button>
                        <h4>
                          {
                            <GetLanguageString props="funds_other_income_tarbiati_course_reimbursment" />
                          }
                        </h4>
                      </Col>
                      <Col xl="1" className="text-center">
                        <Button
                          className="btn-success dim btn-large-dim"
                          onClick={() =>
                            history.push({
                              pathname: `/funds/otherIncomeHelpFromMuqamiTanzeem`,
                            })
                          }
                        >
                          <IoCashOutline size={50} />
                        </Button>
                        <h4>
                          {
                            <GetLanguageString props="funds_other_income_assistance_from_muqami_tanzeem" />
                          }
                        </h4>
                      </Col>
                    </>
                  )}
                  <Col xl="1" className="text-center">
                    <Button
                      className="btn-warning dim btn-large-dim"
                      onClick={() =>
                        history.push({
                          pathname: `/funds/assetDonation`,
                        })
                      }
                    >
                      <IoCashOutline size={50} />
                    </Button>
                    <h4>
                      {<GetLanguageString props="funds_asset_donation" />}
                    </h4>
                  </Col>
                </>
              )}
            </Row>
          </div>
        </div>
      </div>

      {!isUsraRole() && (
        <div
          style={{ marginTop: "-50px", padding: "5px" }}
          className="wrapper wrapper-content wrapper-custom"
        >
          <div className="ibox">
            <div className="ibox-content panel-body">
              <h3>{<GetLanguageString props="sidebar_funds_expenses" />}</h3>

              <Row>
                <Col xl="1" className="text-center">
                  <Button
                    className="btn-success dim btn-large-dim"
                    onClick={() =>
                      history.push({
                        pathname: `/funds/expenseFromCashInHand`,
                      })
                    }
                  >
                    <IoCashOutline size={50} />
                  </Button>
                  <h4>
                    {
                      <GetLanguageString props="finance_expense_cash_in_hand" />
                    }
                  </h4>
                </Col>
                <Col xl="1" className="text-center">
                  <Button
                    className="btn-info dim btn-large-dim"
                    onClick={() =>
                      history.push({
                        pathname: `/funds/expenseFromAmanat`,
                      })
                    }
                  >
                    <IoCashOutline size={50} />
                  </Button>
                  <h4>
                    {
                      <GetLanguageString props="finance_expense_amanat_account" />
                    }
                  </h4>
                </Col>
                {unitTypeName === "Tanzeem" && (
                  <Col xl="1" className="text-center">
                    <Button
                      className="btn-warning dim btn-large-dim"
                      onClick={() =>
                        history.push({
                          pathname: `/funds/expenseHalqaShare`,
                        })
                      }
                    >
                      <IoCashOutline size={50} />
                    </Button>
                    <h4>
                      {
                        <GetLanguageString props="funds_halqa_share" />
                      }
                    </h4>
                  </Col>
                )}
                <Col xl="1" className="text-center">
                  <Button
                    className="btn-primary dim btn-large-dim"
                    onClick={() =>
                      history.push({
                        pathname: `/funds/manageExpense`,
                      })
                    }
                  >
                    <BsWallet2 size={50} />
                  </Button>
                  <h4>{<GetLanguageString props="manage_expense" />}</h4>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      )}

      {!isUsraRole() && (
      <div
        style={{ marginTop: "-10px", padding: "5px" }}
        className="wrapper wrapper-content wrapper-custom"
      >
        <div className="ibox">
          <div className="ibox-content panel-body">
            <h3>{<GetLanguageString props="transfer" />}</h3>

            <Row>
              <Col xl="1" className="text-center">
                <Button
                  className="btn-warning dim btn-large-dim"
                  onClick={() =>
                    history.push({
                      pathname: `/funds/transferCashInHandToAmanat`,
                    })
                  }
                >
                  <FaMoneyBillTransfer />
                </Button>
                <h4>
                  {
                    <GetLanguageString props="transactions_cashinhand_to_amanat_account" />
                  }
                </h4>
              </Col>
              <Col xl="1" className="text-center">
                <Button
                  className="btn-danger dim btn-large-dim"
                  onClick={() =>
                    history.push({
                      pathname: `/funds/transferAmanatToCashInHand`,
                    })
                  }
                >
                  <FaMoneyBillTransfer />
                </Button>
                <h4>
                  {
                    <GetLanguageString props="transactions_amanat_to_cash_in_hand_account" />
                  }
                </h4>
              </Col>
              {unitTypeName === "Halqa" && (
                <Col xl="1" className="text-center">
                  <Button
                    className="btn-success dim btn-large-dim"
                    onClick={() =>
                      history.push({
                        pathname: `/funds/transferMarkazShare`,
                      })
                    }
                  >
                    <FaMoneyBillTransfer />
                  </Button>
                  <h4>
                    {
                      <GetLanguageString props="funds_markaz_share" />
                    }
                  </h4>
                </Col>
              )}
              <Col xl="1" className="text-center">
                <Button
                  className="btn-info dim btn-large-dim"
                  onClick={() =>
                    history.push({
                      pathname: `/funds/manageTransfer`,
                    })
                  }
                >
                  <FaExchangeAlt />
                </Button>
                <h4>
                  {<GetLanguageString props="transactions_manage_transfer" />}
                </h4>
              </Col>
            </Row>
          </div>
        </div>
      </div>
      )}
    </>
  );
};

export default withRouter(QuickManageFund);
